export var isSandbox = function(url) {
    return /sandbox(\.oci)?\.faire\.team/.test(url);
};
